module.exports = __webpack_public_path__ + "jab/media/overview-selected.344e71d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/overview-selected.svg
// module id = 133
// module chunks = 0